"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _useAuthService2 = require("../hooks/useAuthService");

var _features = require("../../Shared/store/features");

var _store = require("../store");

var _AuthLoading = _interopRequireDefault(require("./AuthLoading"));

var _AuthErrorMessage = _interopRequireDefault(require("./AuthErrorMessage"));

var Authorization = function Authorization(_ref) {
  var featureFlag = _ref.featureFlag,
      integrationName = _ref.integrationName;
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useLocation = (0, _reactRouterDom.useLocation)(),
      search = _useLocation.search;

  var _ref2 = _queryString.default.parse(search),
      next = _ref2.next;

  var _useAuthService = (0, _useAuthService2.useAuthService)(),
      logoutUrl = _useAuthService.logoutUrl;

  var isFeatureFlagsLoading = (0, _reactRedux.useSelector)(_features.Features.selectors.getFeaturesIsLoading);
  var isAppFeatureEnabled = (0, _reactRedux.useSelector)(_features.Features.selectors.hasFeatureFlag(featureFlag));
  var logout = (0, _react.useCallback)(function () {
    dispatch((0, _store.logoutRequest)(logoutUrl));
  }, [dispatch, logoutUrl]);

  if (isFeatureFlagsLoading) {
    return /*#__PURE__*/_react.default.createElement(_AuthLoading.default, null);
  }

  if (!isAppFeatureEnabled) {
    return /*#__PURE__*/_react.default.createElement(_AuthErrorMessage.default, {
      redirect: logout,
      error: "".concat(integrationName, " integration app is not available for your organisation"),
      errorText: "Unable to access ".concat(integrationName, " integration app. Please, contact your program administrator."),
      singleColumn: true
    });
  }

  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: next || '/'
  });
};

var _default = /*#__PURE__*/(0, _react.memo)(Authorization);

exports.default = _default;